// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_3hFr5"};